import { useQueryClient } from '@tanstack/react-query';
import type { ContentObject, GivingContentObjectDetail, GivingContentObjectList } from 'models';
import { useCallback } from 'react';
import { getGivingDetailQueryKey } from '../queries';

export const useUpdateGivingBookmark = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (params: { contentObject: GivingContentObjectDetail | GivingContentObjectList }) => {
      queryClient.setQueriesData<ContentObject>(
        { queryKey: getGivingDetailQueryKey({ givingId: params.contentObject.giving.id, view: 'internal' }) },
        (giving) => {
          if (!giving) {
            return giving;
          }

          return { ...giving, bookmarked: !params.contentObject.bookmarked };
        },
      );
    },
    [queryClient],
  );
};
